import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Wrench } from "lucide-react";

interface Step {
  title?: string;
  description?: string;
  step?: string; // alias for title
  details?: string; // alias for description
}

interface FixStepsProps {
  title?: string;
  steps: Step[];
}

export const FixSteps = ({ title = "How to Fix This", steps }: FixStepsProps) => {
  return (
    <Card className="border-primary/30">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <Wrench className="h-5 w-5 text-primary" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ol className="space-y-6">
          {steps.map((stepItem, index) => (
            <li key={index} className="flex gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm">
                {index + 1}
              </div>
              <div>
                <h4 className="font-semibold mb-1">{stepItem.title || stepItem.step}</h4>
                <p className="text-muted-foreground">{stepItem.description || stepItem.details}</p>
              </div>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  );
};
